module.exports = __webpack_public_path__ + "static/img/logo_002.dfb6af4f.png";